function cartRefresh() {
  fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
    async (response2) => {
      const cartContent = await response2.json();
   
      document.getElementById('mini-cart').open = true;

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
           
           
          },
        })
      );
    }
  );
}




let featuredSwiper = null;

function initFeaturedCollectionSwiper() {
  const container = document.querySelector('product-recommendations .custom-swiper-recommended-product');

  if (!container) {
    return false;
  }

  // Destroy previous instance if it exists
  if (featuredSwiper) {
    featuredSwiper.destroy(true, true);
  }

  featuredSwiper = new Swiper('product-recommendations .custom-swiper-recommended-product', {
    slidesPerView: "auto",
    centeredSlides: false,
    spaceBetween: 4,
    loop: false,
    navigation: {
      nextEl: 'product-recommendations .swiper-button-next',
      prevEl: 'product-recommendations .swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        centeredSlides: false,
        loop: false,
        spaceBetween: 4
      },
      600: {
        slidesPerView: 2,
        loop: false,
        centeredSlides: false,
        spaceBetween: 4
      },
      1000: {
        slidesPerView: 3,
        loop: false,
        centeredSlides: false,
        spaceBetween: 4
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 4
      },
      1600: {
        slidesPerView: 5,
        spaceBetween: 4
      }
    }
  });
}

// Debounce function to limit how often resize fires
function debounce(func, wait = 300) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}



// Re-init on resize
window.addEventListener('resize', debounce(() => {
  initFeaturedCollectionSwiper();
}));



  initFeaturedCollectionSwiper();



$('.custom-video-play-pdp').on('click', function() {
  $('.video-player-active').first().trigger('click');

   const target = $('.flickity-viewport').first();
  if (target.length) {
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 600); // Adjust duration (600ms) as needed
  }
  
});



(function() {
    if (window.location.search.includes("cart-drawer-open")) {
        let miniCart = document.getElementById("mini-cart");
        
        if (miniCart) {
            miniCart.open = true; // Open immediately if found
        } else {
            // If not found yet, retry when DOM is ready
            document.addEventListener("DOMContentLoaded", function() {
                let miniCartLoaded = document.getElementById("mini-cart");
                if (miniCartLoaded) {
                    miniCartLoaded.open = true;
                }
            });
        }
    }
})();


// const productInfo = document.querySelector('.product__info');
// const addToCartButton = document.getElementById('AddToCart');

// function adjustProductInfo() {
//   if (!productInfo || !addToCartButton) return;

//   const viewportHeight = window.innerHeight;
//   const scrollY = window.scrollY;

//   // Get position of the Add to Cart button relative to the page
//   const addToCartButtonRect = addToCartButton.getBoundingClientRect();
//   const addToCartButtonTop = addToCartButtonRect.top + scrollY;

//   // Distance from the top of the page to the Add to Cart button
//   const distanceToTop = addToCartButtonTop - scrollY;

//   console.log('--- Scroll Data ---');
//   console.log('Viewport Bottom Position: ', scrollY + viewportHeight);
//   console.log('Add to Cart Button Position: ', addToCartButtonTop);
//   console.log('Distance from top to Add to Cart button: ', distanceToTop);

//   // Variable to control the shift of the product info
//   let shiftTop = 0;

//   // If the Add to Cart button is not visible within the viewport
//   if (distanceToTop > 50) {
//     // Get the current position of the productInfo
//     const productInfoRect = productInfo.getBoundingClientRect();
//     const productInfoBottom = productInfoRect.bottom + scrollY;

//     // Calculate the distance from the bottom of productInfo to the viewport
//     const distanceFromBottom = productInfoBottom - (scrollY + viewportHeight);

//     console.log('Distance from bottom of productInfo: ', distanceFromBottom);

//     // If productInfo is below the viewport, shift it upwards
//     if (distanceFromBottom > 0) {
//       shiftTop = distanceFromBottom;
//       console.log('Shifting productInfo up by: ', shiftTop);
//     }
//   }

//   // Once the button is within 50px of the viewport bottom, allow the extra 50px shift
//   if (distanceToTop <= 50) {
//     shiftTop = 50;  // Allow the additional 50px shift
//     console.log('Allowing 50px extra shift as Add to Cart button is within 50px of viewport top');
//   }

//   // Apply the calculated shift to the productInfo div
//   productInfo.style.transition = "top 0.3s ease"; // Smooth transition for top position
//   productInfo.style.top = `-${shiftTop}px`;
// }

// // Attach the function to handle scroll and resize events
// window.addEventListener('scroll', adjustProductInfo);
// window.addEventListener('resize', adjustProductInfo);


